import React from 'react';
import Media from '../';

import './_web-app.scss';

import exampleApp1 from './assets/WebApp-1.png';
import exampleApp2 from './assets/WebApp-2.png';
import exampleApp3 from './assets/WebApp-3.png';

class WebApp extends Media {
  renderImages() {
    return (
      <div id="apps">
        <div><img src={exampleApp1} alt="Cownter Web App" /></div>
        <div><img src={exampleApp2} alt="Lighthouse Web App" /></div>
        <div><img src={exampleApp3} alt="RasBrewy Pi Web App" /></div>
      </div>
    );
  }

  renderContent() {
    const { item } = this.props;
    return (
      <section id="web-app" className="media-item">
        <div id="title">
          <h2>Web Apps</h2>
        </div>

        <div id="imagery">
          {this.renderImages()}
        </div>

        <div id="media-content">
          <p>{item.description}</p>
        </div>
      </section>

    );
  }
}

export default WebApp;



// WEBPACK FOOTER //
// ./src/components/media/web-app/index.js